import { FC } from "preact/compat";
import { useLocalBool } from "~/hooks";
import { HintMessageProps } from "./interfaces";
import CloseIcon from "@material-design-icons/svg/outlined/close.svg";
import InfoIcon from "@material-design-icons/svg/outlined/info.svg";
import cn from "classnames";

const HintMessage: FC<HintMessageProps> = ({
    storageKey,
    children,
    className,
}) => {
    const isHintDismissed = useLocalBool(storageKey);

    if (isHintDismissed.value) {
        return null;
    }

    return (
        <div
            className={cn(
                "bg-white px-4 py-1 border border-gray-300 rounded-2xl text-gray-600 text-sm",
                "flex items-center justify-between gap-x-6 whitespace-nowrap",
                className,
            )}
        >
            <div className="flex items-center gap-x-2">
                <InfoIcon width="20" height="20" className="fill-current" />
                {typeof children === "string" ? (
                    <span>{children}</span>
                ) : (
                    children
                )}
            </div>
            <button
                title="Close hint"
                type="button"
                onClick={() => {
                    isHintDismissed.value = true;
                }}
                className="hover:bg-gray-100 hover:text-red-500 rounded-full transition duration-100"
            >
                <CloseIcon width="20" height="20" className="fill-current" />
            </button>
        </div>
    );
};

export default HintMessage;
